import sendxAPI from "../xAPI";
import { v4 as uuidv4 } from "uuid";

const initialState = {
  uuid: uuidv4(),
  heldObject: {
    type: null,
    id: -1,
    htmlObj: null,
  },
  targetList: [],
  lastDrop: {
    lastHeld: null,
    lastTarget: null,
  },
  interactions: [],
  scale: 1,
  notebookExpanded: true,
  resultFeedback: null,
  lang: null,
  supportedLangs: [
    "af",
    "ar",
    "az",
    "bn",
    "de",
    "en",
    "es",
    "fr",
    "hi",
    "id",
    "it",
    "ja",
    "ka",
    "ko",
    "mr",
    "ms",
    "ne",
    "nl",
    "pl",
    "pt",
    "ro",
    "ru",
    "sw",
    "ta",
    "th",
    "tl",
    "tr",
    "uk",
    "ur",
    "vi",
    "zh",
    "zu",
  ],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "SET_HELD_OBJECT":
      return { ...state, ...{ heldObject: action.payload } };

    case "SET_TARGET_LIST":
      return { ...state, ...{ targetList: action.payload } };

    case "PUSH_INTERACTIONS":
      return {
        ...state,
        ...{ interactions: [...state.interactions, ...action.payload] },
      };

    case "SET_LANG":
      return { ...state, ...{ lang: action.payload.lang } };

    case "SET_LAST_DROP":
      if (
        action.payload.lastHeld !== null &&
        action.payload.lastHeld.type !== null &&
        action.payload.lastTarget !== null &&
        action.payload.lastTarget.type !== null
      ) {
        // xAPI statement
        sendxAPI({
          // Type of statement
          verb: {
            description: "focused",
            address: "http://id.tincanapi.com/verb/focused",
          },
          // Where the action occured
          context: action.payload.lastHeld.type,
          // Result of the action
          result: {
            success: true,
            response: action.payload.lastTarget.type,
          },
        });
      }

      return { ...state, ...{ lastDrop: action.payload } };

    case "SET_SCENE_SCALE":
      // xAPI statement
      sendxAPI({
        // Type of statement
        verb: {
          description: "assigned",
          address: "http://id.tincanapi.com/verb/assigned",
        },
        // Where the action occured
        context: "Scene scale",
        // Result of the action
        result: {
          success: true,
          response: action.payload.scale,
        },
      });

      return { ...state, ...{ scale: action.payload.scale } };

    case "TOGGLE_NOTEBOOK_EXPANDED":
      // xAPI statement
      sendxAPI({
        // Type of statement
        verb: {
          description:
            !state.notebookExpanded === true ? "expanded" : "collapsed",
          address:
            !state.notebookExpanded === true
              ? "http://id.tincanapi.com/verb/expanded"
              : "http://id.tincanapi.com/verb/collapsed",
        },
        // Where the action occured
        context: "Lab notebook",
        // Result of the action
        result: {
          success: true,
          response: !state.notebookExpanded,
        },
      });

      return { ...state, ...{ notebookExpanded: !state.notebookExpanded } };

    case "SAVE_RESULT_FEEDBACK":
      return { ...state, ...{ resultFeedback: action.payload.resultFeedback } };

    default:
      return state;
  }
};
